// extracted by mini-css-extract-plugin
export default {"trainingAdvantageItem":"trainingAdvantageItem_trainingAdvantageItem__9CCp4"};